// components/SuperAdminLayout.js
import React, { useState } from 'react';
import SuperAdminSidebar from './SuperAdminSidebar';
import { Outlet ,useLocation} from 'react-router-dom';
import SuperadminTopbar from './SuperadminTopbar';


const SuperAdminLayout = () => {
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  return (
    <div className="app">
      <SuperAdminSidebar
        expanded={sidebarExpanded}
        toggleSidebar={() => setSidebarExpanded(!sidebarExpanded)}
      />
      <div className={`main-content-wrapper ${sidebarExpanded ? 'expanded' : 'collapsed'}`}>
        <nav className="topbar-wrapper">
          <SuperadminTopbar/>
        </nav>
        <main className="page-content custom-ak-scollbar">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default SuperAdminLayout;
